module.exports = __webpack_public_path__ + "img/wx_icon.b764d79.png";